import { render, staticRenderFns } from "./TableBranceOther.vue?vue&type=template&id=5180c580&"
import script from "./TableBranceOther.vue?vue&type=script&lang=js&"
export * from "./TableBranceOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports